import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Underline } from "@/components/typography/Body14Underline";
import { Table } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { profileState } from "../../../atoms/user/profile-state";
import { ButtonColor } from "../../../common/enum/button-color";
import { Permission } from "../../../common/enum/permission";
import { UserStatus } from "../../../common/enum/user-status";
import { UserDto } from "../../../types/dto/user-dto";
import { RefreshButton } from "../../button/RefreshButton";
import { CustomCell } from "../CustomCell";

interface Props {
  data: UserDto;
  index: number;
  startIndex: number;
  openStatusModal: (data: UserDto) => void;
}

export const Row: React.FC<Props> = ({
  data,
  index,
  startIndex,
  openStatusModal,
}) => {
  const navigate = useNavigate();

  const profile = useRecoilValue<UserDto>(profileState);

  const moveToDetail = () => {
    if (data.id === profile?.id) {
      navigate(`/profile/my-profile`);
      return;
    }
    window.open(`/profile/detail/${data.id}`, "_blank");
  };

  const getStatusDisplay = () => {
    if (data.status !== UserStatus.ACTIVE) {
      return {
        text: "비활성화",
        color: ButtonColor.RED,
      };
    }

    const permission = data.permission;
    if (permission === Permission.WRITE) {
      return {
        text: "쓰기",
        color: ButtonColor.CUSTOM_GRAY,
      };
    } else if (permission === Permission.READ) {
      return {
        text: "읽기",
        color: ButtonColor.CUSTOM_GRAY,
      };
    } else {
      return {
        text: "미지정",
        color: ButtonColor.CUSTOM_GRAY,
      };
    }
  };

  const statusDisplay = getStatusDisplay();

  return (
    <Table.Row
      key={data.id}
      className="bg-white dark:border-gray-700 dark:bg-gray-800"
    >
      <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white h-[54px] p-0">
        <CustomCell>
          <Body14Regular>{startIndex - index}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <div onClick={moveToDetail}>
            <Body14Underline>{data.name}</Body14Underline>
          </div>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{data.department?.name}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{data.phone}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{data.email}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell className="flex items-center justify-center">
          <RefreshButton
            color={statusDisplay.color}
            handleClick={() => openStatusModal(data)}
          >
            {statusDisplay.text}
          </RefreshButton>
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
